import axios from "axios";

const API_BASE = "https://localhost:7231";

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

export async function getProjectDiagnostics(projectId) {
    const res = await api.get(`/api/dev-diagnostics/project/${projectId}`);
    return res.data;
}

export async function getModuleSnapshot(projectId) {
    const res = await api.get(`/api/dev-diagnostics/modules/${projectId}`);
    return res.data;
}

export async function getRedeployRuns(projectId) {
    const res = await api.get(`/api/dev-diagnostics/redeploy/runs/${projectId}`);
    return res.data;
}

export async function insertRedeployRun(payload) {
    const res = await api.post("/api/dev-diagnostics/redeploy/insert-run", payload);
    return res.data;
}

export async function getSeedSnapshot(industry) {
    const query = industry ? `?industry=${encodeURIComponent(industry)}` : "";
    const res = await api.get(`/api/dev-diagnostics/seeds${query}`);
    return res.data;
}

export async function validateJson(json) {
    const res = await api.post("/api/dev-diagnostics/json/validate", { json });
    return res.data;
}

export async function fixWebsiteIdentity(projectId) {
    const res = await api.post(`/api/dev-diagnostics/project/${projectId}/fix-website-identity`);
    return res.data;
}

export async function pushTestItems(projectId, moduleKey = "products") {
    const res = await api.post(`/api/dev-diagnostics/project/${projectId}/push-test-items`, {
        moduleKey
    });
    return res.data;
}

export async function getSiteFileSnapshot(projectId) {
    const res = await api.get(`/api/dev-diagnostics/project/${projectId}/site-file-snapshot`);
    return res.data;
}
export async function getGeneratedFiles(projectId) {
    const res = await api.get(`/api/dev-diagnostics/project/${projectId}/generated-files`);
    return res.data;
}

export async function getSmartRedeployPreview(projectId, moduleKey) {
    const { data } = await api.get(
        `/dev-diagnostics/smart-redeploy/preview/${projectId}`,
        { params: { moduleKey } }
    );
    return data;
}

export async function queueSmartRedeploy(projectId, moduleKey) {
    return insertRedeployRun({
        projectId,
        moduleKey,
        status: "pending",
        reason: `Smart redeploy playground test for ${moduleKey}`
    });
}

export async function getDeployVersions(projectId) {
    const { data } = await api.get(
        `/dev-diagnostics/project/${projectId}/deploy-versions`
    );
    return data;
}

export async function rollbackVersion(projectId, version) {
    const { data } = await api.post(
        `/dev-diagnostics/project/${projectId}/rollback-version`,
        { version }
    );
    return data;
}